export const enum ColumnVisibilityFor {
  MATERIAL_REQUEST_COMPARISION = "MATERIAL_REQUEST_COMPARISION",
  MATERIAL_REQUEST_NEGOTIATION = "MATERIAL_REQUEST_NEGOTIATION",
  MATERIAL_REQUEST_VIEW = "MATERIAL_REQUEST_VIEW",
  MRF_TO_PO = "MRF_TO_PO",
  MRF_TO_PO_VIEW = "MRF_TO_PO_VIEW",
  RFQ_TO_PO = "RFQ_TO_PO",
  MATERIAL_REQUEST_DETAILS = "MATERIAL_REQUEST_DETAILS",
  MRF_TO_PO_ADD = "MRF_TO_PO_ADD",
  VIEW_REQUEST_QUOTATION = "VIEW_REQUEST_QUOTATION",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  REQUEST_FOR_QUOTATION = "REQUEST_FOR_QUOTATION",
  ITEMS_OB = "ITEMS_OB",
  ITEMS_LIST = "ITEMS_LIST",
  PURCHASE_ENTRY_ADD = "PURCHASE_ENTRY_ADD",
  PURCHASE_ENTRY_VIEW = "PURCHASE_ENTRY_VIEW",
  PURCHASE_ENTRY_VALIDATE = "PURCHASE_ENTRY_VALIDATE",
  ASSOCIATE_TO_SUPPLIER = "ASSOCIATE_TO_SUPPLIER",
  ASSIGN_TO_SUPPLIER = "ASSIGN_TO_SUPPLIER",
  VIEW_SUPPLIER = "VIEW_SUPPLIER",
  STOCK_ENTRY_WITHOUT_PURCHASE_ENTRY = "STOCK_ENTRY_WITHOUT_PURCHASE_ENTRY",
  STOCK_BALANCE = "STOCK_BALANCE",
  STOCK_BALANCE_LOCATION_DETAILS = "STOCK_BALANCE_LOCATION_DETAILS",
  MAPS_COMPANY_DETAILS = "MAPS_COMPANY_DETAILS",
  REPORTS_ASSET_DETAILS = "REPORTS_ASSET_DETAILS",
  PROJECTS_LIST = "PROJECTS_LIST",
  JUNCTIONS_LIST = "JUNCTIONS_LIST",
  TICKET_LIST = "TICKET_LIST",
  TICKET_LIST_REPORT = "TICKET_LIST_REPORT",
  STOCK_ASSET = "STOCK_ASSET",
  VENDOR_WISE_JUNCTIONS = "VENDOR_WISE_JUNCTIONS",
  JUNCTION_TYPE = "JUNCTION_TYPE",
  GROUPING_ASSET = "GROUPING_ASSET",
  MOM_ATTENDANCE_LIST = "MOM_ATTENDANCE_LIST",
  MOM_ATTENDED_DETAILS = "MOM_ATTENDED_DETAILS",
  CALIBRATION_DETAILS = "CALIBRATION_DETAILS",
  WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
  ASSET_LIST = " ASSET_LIST",
}
